import FuseUtils from '@fuse/utils/FuseUtils';
import jwtDecode from 'jwt-decode';
import authRoles from '../../authRoles';
import apolloClient from 'src/app/apolloClient';
import { SIGN_IN_MUTATION } from 'src/graphql/SignIn';
import { PROFILE_QUERY } from 'src/graphql/profile';

/* eslint-disable camelcase */

class JwtService extends FuseUtils.EventEmitter {
  init() {
    // this.setInterceptors();
    this.handleAuthentication();
  }

  handleAuthentication = () => {
    const access_token = this.getAccessToken();

    if (!access_token) {
      this.emit('onNoAccessToken');

      return;
    }

    if (this.isAuthTokenValid(access_token)) {
      this.setSession(access_token);
      this.emit('onAutoLogin', true);
      console.log('onAutoLogin');
    } else {
      this.setSession(null);
      this.emit('onAutoLogout', 'access_token expired');
    }
  };

  // signInWithEmailAndPassword = (email, password) => {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(jwtServiceConfig.signIn, {
  //         data: {
  //           email,
  //           password,
  //         },
  //       })
  //       .then((response) => {
  //         if (response.data.user) {
  //           this.setSession(response.data.access_token);
  //           resolve(response.data.user);
  //           this.emit('onLogin', response.data.user);
  //         } else {
  //           reject(response.data.error);
  //         }
  //       });
  //   });
  // };

  signInWithUsernameAndPassword = (identifier, password) => {
    return new Promise((resolve, reject) => {
      apolloClient
        .mutate({
          mutation: SIGN_IN_MUTATION,
          variables: {
            identifier,
            password,
          },
        })
        .then(async (response) => {
          if (response.data.login.token) {
            this.setSession(response.data.login.token);
            const profile = await apolloClient.query({
              query: PROFILE_QUERY,
            });
            resolve(profile.data.profile);
            this.emit('onLogin', {
              data: profile.data.profile,
              // data: {
              //   id: 1,
              //   userName: 'milad',
              //   fName: 'me',
              //   lName: 'moradian',
              //   mobNumber: '09903443599',
              //   melliCode: '0025890645',
              //   email: 'miladMoradian81@gmail.com',
              //   password: null,
              //   level: 1,
              //   createTime: 1732702922,
              //   chatAdmin: '0',
              //   personalCode: 25,
              //   status: '1',
              //   userId: 1,
              //   category: 95,
              // },
              role: ['0', '1', '2', '3', '4', '5', '6', '7'],
              // role: authRoles[response.data.userInfo.level],
            });
          }
        });
    });
  };

  signInWithToken = () => {
    return new Promise((resolve, reject) => {
      const access_token = this.getAccessToken();
      if (access_token) {
        this.setSession(access_token);
        resolve(true);
        this.setSession(access_token);
      } else {
        this.logout();
      }
    });
  };

  setSession = (access_token) => {
    if (access_token) {
      localStorage.setItem('jwt_access_token', access_token);
      // axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
    } else {
      localStorage.removeItem('jwt_access_token');
      // delete axios.defaults.headers.common.Authorization;
    }
  };

  logout = () => {
    this.setSession(null);
    this.emit('onLogout', 'Logged out');
  };

  isAuthTokenValid = (access_token) => {
    if (!access_token) {
      return false;
    }
    const decoded = jwtDecode(access_token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      console.warn('access token expired');
      return false;
    }

    return true;
  };

  getAccessToken = () => {
    return window.localStorage.getItem('jwt_access_token');
  };
}

const instance = new JwtService();

export default instance;
